import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { MatDialogRef } from '@angular/material/dialog';

import { SavedFilter } from './filter.service';

@Component({
  selector: 'uikit-manage-saved-filters-dialog',
  template: `
    <h2 matDialogTitle>{{ 'FRONTEND.UIKIT.VA_FILTER.MANAGE_YOUR_SAVED_FILTERS' | translate }}</h2>
    <mat-dialog-content>
      <mat-list>
        <mat-list-item *ngFor="let option of savedFilters | async">
          <span>{{ option.name }}</span>
          <button mat-icon-button (click)="removeSavedFilter.emit(option.name)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </mat-dialog-content>
  `,
  styleUrls: ['./manage-saved-filters-dialog.component.scss'],
  standalone: false,
})
export class ManageSavedFiltersDialogComponent implements OnInit {
  @Input() savedFilters: Observable<SavedFilter[]>;
  @Output() removeSavedFilter = new EventEmitter<string>();

  constructor(public dialogRef: MatDialogRef<ManageSavedFiltersDialogComponent>) {}

  ngOnInit(): void {
    this.savedFilters.subscribe((savedFilters) => this.closeDialogIfSavedFiltersEmpty(savedFilters));
  }

  closeDialogIfSavedFiltersEmpty(savedFilters: SavedFilter[]): void {
    if (!savedFilters.length) {
      this.dialogRef.close();
    }
  }
}
